import searchSuggestionsV2 from "@faire/web-api--source/api/v2/search/suggestions/post";
import { ISearchSuggestionRequest } from "@faire/web-api--source/indigofair/data/ISearchSuggestionRequest";
import { ISearchSuggestionResponse } from "@faire/web-api--source/indigofair/data/ISearchSuggestionResponse";
import {
  UseQueryResult,
  keepPreviousData,
  useQuery,
} from "@tanstack/react-query";

import { getSearchSuggestionsQueryKey } from "@faire/retailer/features/SearchSuggestions-v2/DataFetching/__internal__/getSearchSuggestionsQueryKey";
import { useSearchSuggestionsThrottledQueryString } from "@faire/retailer/features/SearchSuggestions-v2/DataFetching/__internal__/useSearchSuggestionsThrottledQueryStringContext";

export const useSearchSuggestionsQuery = (
  queryString?: string,
  options?: { enabled?: boolean }
) => {
  const userQueryString = useSearchSuggestionsThrottledQueryString();
  const query = queryString ?? userQueryString;

  const result: UseQueryResult<ISearchSuggestionResponse & { query?: string }> =
    useQuery({
      queryKey: getSearchSuggestionsQueryKey(query),
      queryFn: async ({ signal }) =>
        searchSuggestionsV2(
          ISearchSuggestionRequest.build({
            query,
          }),
          { signal }
        ).then((response) => {
          return {
            ...response,
            query,
          };
        }),
      placeholderData: keepPreviousData,
      ...options,
    });

  return result;
};
